import { Box, Card, Divider, Link } from "@mui/material";
import localize from "../../../common/localize";
import { BackForeColor } from "../../../components/common/BackForeColor";
import TotalValueItem from "./TotalValueItem";
import PaymentIcon from "./PaymentIcon";
import BillIcon from "./BillIcon";

export default function EventItem({ event }) {
  return (
    <Card variant="outlined" className="flex flex-col w-full gap-2 p-2">
      <Box className="flex justify-between">
        <Box className="two_columns_grid">
          <label className="text-xs">
            <b>{localize.code}:</b>
          </label>
          <Link
            className="text-xs"
            color="primary"
            underline="always"
            href="#"
            onClick={() => {
              window.open(`/events/detail/${event.Id}`, "_blank");
            }}
          >{`${event.Code}`}</Link>
        </Box>

        {event.ProceedingInfo && (
          <label className="text-xs">{event.ProceedingInfo?.Name}</label>
        )}
      </Box>

      <Divider />

      <Box className="w-full flex">
        <Box className="two_columns_grid">
          <Box className="flex items-center" sx={{ whiteSpace: '"nowrap' }}>
            <label className="text-xs">
              <b>{localize.event_type}:</b>
            </label>
          </Box>
          <BackForeColor
            styleName="text-xs"
            backColor={event.EventType.BackgroundColor}
            foreColor={event.EventType.ForegroundColor}
            text={event.EventType.Name}
          />
          <Box className="flex items-center" sx={{ whiteSpace: '"nowrap' }}>
            <label className="text-xs">
              <b>{localize.execution_status}:</b>
            </label>
          </Box>

          <BackForeColor
            backColor={
              event.OperationalStatus === 0
                ? "white"
                : event.CurrentStatus?.BackgroundColor
            }
            foreColor={
              event.OperationalStatus === 0
                ? "red"
                : event.CurrentStatus?.ForegroundColor
            }
            text={
              event.OperationalStatus === 0
                ? localize.cancelled
                : event.CurrentStatus?.Name
            }
            styleName={
              event.OperationalStatus === 0
                ? "cancelled_operational_status text-xs mt-1"
                : "text-xs mt-1"
            }
          />
        </Box>
      </Box>

      <Divider />

      <Box className="flex w-full justify-between">
        <Box className="two_columns_grid">
          <label className="text-xs">
            <b>{localize.client}:</b>
          </label>
          <label className="text-xs">
            {event.ReporterName ?? event.Client?.Name}
          </label>
          <label className="text-xs">
            <b>{localize.address}:</b>
          </label>
          <label className="text-xs">
            {event.Address
              ? `${event.Address} ${event.AddressComplement ?? ""}`
              : event.Client.Address}
          </label>
          <label className="text-xs">
            <b>{localize.phone_number}:</b>
          </label>
          <label className="text-xs">
            {event.ReporterPhoneNumber ?? event.Client?.PhoneNumber}
          </label>

          <label className="text-xs">
            <b>{localize.total_value}:</b>
          </label>
          <TotalValueItem notCentered customStyle="text-xs" item={event} />

          <label className="text-xs">
            <b>{localize.assigned_to}:</b>
          </label>
          {event.PersonalAssigned ? (
            <label className="text-xs">{`${event.PersonalAssigned.SurName} ${event.PersonalAssigned.LastName}`}</label>
          ) : (
            <label className="text-xs">{localize.no_data}</label>
          )}
          <label className="text-xs">
            <b>{localize.creation_date}:</b>
          </label>
          <label className="text-xs">
            {new Date(event.CreationDate).toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}
          </label>
        </Box>

        <Box className="flex flex-col gap-2">
          <Box className="flex gap-2 items-center justify-between">
            <label className="text-xs">
              <b>{localize.payed}: </b>
            </label>
            <PaymentIcon item={event} />
          </Box>
          <Box className="flex gap-2 items-center">
            <label className="text-xs">
              <b>{localize.billed}:</b>
            </label>
            <BillIcon item={event} />
          </Box>
        </Box>
      </Box>
    </Card>
  );
}
